import React from 'react';
import { motion } from 'framer-motion';
import { Check, FileText, Table, ListChecks, MessageSquare } from 'lucide-react';
export function DeliverablesSection() {
  const items = [{
    icon: FileText,
    title: 'PDF Completo',
    desc: 'Lectura rápida, sin relleno. Todo el sistema explicado paso a paso.'
  }, {
    icon: Table,
    title: 'Plantilla Google Sheets',
    desc: "Tu 'Cash-to-Close Tracker' para llevar el control de cada centavo."
  }, {
    icon: ListChecks,
    title: 'Checklists de Control',
    desc: 'Listas de verificación para 72h antes, 24h antes y el día del cierre.'
  }, {
    icon: MessageSquare,
    title: 'Scripts de Copiar/Pegar',
    desc: 'Mensajes exactos para enviar a tu lender, title company y realtor.'
  }];
  return <section className="py-24 bg-cream-50 text-navy-900" data-id="element-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-34">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-35">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 font-serif" data-id="element-36">
              Lo que recibes inmediatamente
            </h2>
            <p className="text-lg text-navy-800/70 mb-10" data-id="element-37">
              No es solo "información". Son las herramientas exactas que
              necesitas para tomar el control de tu cierre.
            </p>

            <div className="space-y-6" data-id="element-38">
              {items.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start p-4 bg-white rounded-xl shadow-sm border border-cream-200" data-id="element-39">
                  <div className="flex-shrink-0 bg-gold-100 p-2 rounded-lg mr-4" data-id="element-40">
                    <item.icon className="w-6 h-6 text-gold-600" data-id="element-41" />
                  </div>
                  <div data-id="element-42">
                    <h3 className="font-bold text-navy-900" data-id="element-43">{item.title}</h3>
                    <p className="text-sm text-navy-800/70" data-id="element-44">{item.desc}</p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative bg-navy-900 p-8 rounded-2xl shadow-2xl text-cream-50" data-id="element-45">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 bg-gold-500 text-navy-900 font-bold px-4 py-2 rounded-lg shadow-lg transform rotate-3" data-id="element-46">
              Acceso Inmediato
            </div>
            <h3 className="text-2xl font-serif font-bold mb-6 text-gold-400" data-id="element-47">
              Scripts incluidos:
            </h3>
            <ul className="space-y-4" data-id="element-48">
              <li className="flex items-center text-cream-200/90" data-id="element-49">
                <Check className="w-5 h-5 text-gold-500 mr-3 flex-shrink-0" data-id="element-50" />
                <span data-id="element-51">A tu lender: Claridad absoluta de cash to close</span>
              </li>
              <li className="flex items-center text-cream-200/90" data-id="element-52">
                <Check className="w-5 h-5 text-gold-500 mr-3 flex-shrink-0" data-id="element-53" />
                <span data-id="element-54">A title/escrow: Instrucciones de wire + monto final</span>
              </li>
              <li className="flex items-center text-cream-200/90" data-id="element-55">
                <Check className="w-5 h-5 text-gold-500 mr-3 flex-shrink-0" data-id="element-56" />
                <span data-id="element-57">A tu realtor: Confirmación de HOA y costos fantasma</span>
              </li>
            </ul>
            <div className="mt-8 pt-8 border-t border-navy-700 text-center" data-id="element-58">
              <p className="text-sm text-cream-200/60 italic" data-id="element-59">
                "El guión que hace que te tomen en serio."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}